import { i18n } from "@lingui/core";

import { messages as enMessages } from "./locales/en/messages.po";
import { messages as ruMessages } from "./locales/ru/messages.po";

export const LOCALES = ["en", "ru"] as const;
export type Locale = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "ru";

export const LOCALE_LABELS: Record<Locale, string> = {
  en: "English",
  ru: "Русский",
};

const STORAGE_KEY = "t3code:locale";

function hasLocaleStorage() {
  return typeof window !== "undefined" && typeof localStorage !== "undefined";
}

export function isLocale(value: unknown): value is Locale {
  return LOCALES.includes(value as Locale);
}

export function getStoredLocale(): Locale {
  if (!hasLocaleStorage()) return DEFAULT_LOCALE;
  const raw = localStorage.getItem(STORAGE_KEY);
  return isLocale(raw) ? raw : DEFAULT_LOCALE;
}

export function setLocale(locale: Locale) {
  if (hasLocaleStorage()) {
    localStorage.setItem(STORAGE_KEY, locale);
  }
  activateLocale(locale);
}

function activateLocale(locale: Locale) {
  i18n.activate(locale);
  if (typeof document !== "undefined") {
    document.documentElement.lang = locale;
  }
}

i18n.load({ en: enMessages, ru: ruMessages });
activateLocale(getStoredLocale());

if (typeof window !== "undefined") {
  window.addEventListener("storage", (event) => {
    if (event.key === STORAGE_KEY) {
      activateLocale(getStoredLocale());
    }
  });
}

export { i18n };
